
































import { defineComponent } from '@nuxtjs/composition-api'

// Types
import { PageContentTilesBlock } from '@/types/cms/page'

export default defineComponent({
  name: 'SupportLinkTiles',

  props: {
    section: {
      type: Object as () => PageContentTilesBlock,
      required: true,
    },
  },

  setup() {
    const getIconClassName = (color: string) => {
      // dynamic class creation does not work since this style is not created
      // https://tailwindcss.com/docs/content-configuration#dynamic-class-names
      // To do, figure out this color mapping from CMS to frontend and make it more generic
      if (color === 'danube') return `group-hover:tw-bg-danube`
      if (color === 'apple') return `group-hover:tw-bg-apple`
      if (color === 'hokey-pokey') return `group-hover:tw-bg-hokey-pokey`
      if (color === 'killarney') return `group-hover:tw-bg-killarney`
      if (color === 'monza') return `group-hover:tw-bg-monza`
      if (color === 'bahama-blue') return `group-hover:tw-bg-bahama-blue`
    }

    return {
      getIconClassName,
    }
  },
})
